import { Buffer } from 'buffer'

export const state = () => {
	return {
		brandingReferralModal: {},
		ttl_branding_modal: null,
		cache_duration_branding_modal: 3600000, // 1 hour
		cache_key_branding_modal: '',
		previewMode: 1, // 0 - mobile, 1 - desktop
	}
}

function isInCacheBrandingModal(state, companyId) {
	if (state.cache_key_branding_modal !== buildCacheKeyBrandingModal(companyId)) {
		return false
	}
	if (state.ttl_branding_modal === null || state.ttl_branding_modal < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyBrandingModal(companyId) {
	return `company:${companyId}:branding-referral-modal`
}

export const getters = {
	isMobilePreview: (state) => state.previewMode === 0,
}

export const actions = {
	async upload(_, { companyId, extension, file_type: fileType, data }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/branding-referral-modal/upload/`, {
				params: { extension },
			})
			.then(async (res) => {
				await useNuxtApp().$api(res.signed_url, {
					method: 'PUT',
					headers: { 'Content-Type': fileType },
					body: Buffer.from(data.replace(/^data:image\/\w+;base64,/, ''), 'base64'),
				})
				return res.remote_url
			})
	},
	async retrieve({ state, commit }, { companyId }) {
		if (isInCacheBrandingModal(state, companyId)) {
			return state.brandingReferralModal
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/branding-referral-modal/`)
			.then((res) => {
				commit('setBrandingModal', { data: res, companyId })
				return res
			})
			.catch((err) => {
				commit('clearCacheBrandingModal')
				throw err
			})
	},

	async partialUpdate({ commit }, { companyId, id, data }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/branding-referral-modal/${id}/`, {
				method: 'PATCH',
				body: data,
			})
			.then((res) => {
				commit('setBrandingModal', { data: res, companyId })
				commit('clearCacheBrandingModal')
			})
			.catch((err) => {
				commit('clearCacheBrandingModal')
				throw err
			})
	},
}

export const mutations = {
	setBrandingModal(state, { data, companyId }) {
		state.brandingReferralModal = data
		state.ttl_branding_modal = Date.now() + state.cache_duration_branding_modal
		state.cache_key_branding_modal = buildCacheKeyBrandingModal(companyId)
	},

	clearCacheBrandingModal(state) {
		state.ttl_branding_modal = null
	},

	setPreviewMode(state, mode) {
		state.previewMode = mode
	},
}
